import "./Pager.scss";

import React from 'react';

export default function Pager(props) {
  const { pager, onClickPage } = props;
  const { prevPage, nextPage, currentPage, pages, pageCount } = pager;
  return <div className="pager">
    <div className={'btn pager__nav pager__nav--first' + (!prevPage ? ' pager__nav--disabled btn--disabled' : '')} onClick={e => {if(prevPage) onClickPage(1)}} >Első</div>
    <div className={'btn pager__nav pager__nav--prev' + (!prevPage ? ' pager__nav--disabled btn--disabled' : '')} onClick={e => {if(prevPage) onClickPage(prevPage)}} >Előző</div>
    {pages.map((page, i) => <div key={i} className={'btn pager__nav pager__nav--page' + (currentPage === page ? ' pager__nav--current btn--active' : null)} onClick={e => {if(currentPage !== page) onClickPage(page)}}>{page}</div>)}
    <div className={'btn pager__nav pager__nav--next ' + (!nextPage ? ' pager__nav--disabled btn--disabled' : '')} onClick={e => {if(nextPage) onClickPage(nextPage)}} >Következő</div>
    <div className={'btn pager__nav pager__nav--last' + (!nextPage ? ' pager__nav--disabled btn--disabled' : '')} onClick={e => {if(nextPage) onClickPage(pageCount)}} >Utolsó</div>
  </div>
};